export const isTrialEnded = (trialStartDate, trialDurationInDays = 30) => {
  if (!trialStartDate) return false;

  const trialStart = new Date(trialStartDate);
  const trialEnd = new Date(trialStart);
  trialEnd.setDate(trialStart.getDate() + trialDurationInDays);
  const currentDate = new Date();
  return currentDate > trialEnd;
};
